import { Box } from '@mui/material';
import React from 'react';

import type { FilterGroup } from '@verantos-dev/types-cohorts';

import { CollapsibleLogicNode } from './CollapsibleLogicNode';
import { LogicConnector } from './LogicConnector';
import type { LogicNode } from '../../utils/analyticalVariable.utils';

interface FilterGroupRendererProps {
  group: FilterGroup;
  onChipClick: (name: string) => void;
}

export const FilterGroupRenderer = ({ group, onChipClick }: FilterGroupRendererProps) => {
  const filters = group.filters as LogicNode[];

  const items: React.ReactNode[] = [];

  filters.forEach((child, idx) => {
    if (idx > 0) {
      items.push(
        <LogicConnector
          key={`connector-${idx}`}
          label={group.operator.toUpperCase()}
          data-testid={`av-logic-connector-${idx}`}
        />
      );
    }
    items.push(
      <CollapsibleLogicNode
        key={`node-${idx}`}
        node={child}
        onChipClick={onChipClick}
        data-testid={`av-logic-section-${idx}`}
      />
    );
  });

  return (
    <Box
      data-testid="av-logic-filter-group"
      sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
    >
      {items}
    </Box>
  );
};
